<article class="card">
	<form class="form">
		<div class="input-container">
			<ng-container *ngIf="isFormInitialized">
				<ng-container *ngTemplateOutlet="buttons; context: { isTop: true }" />
				<ng-container *ngIf="isFullScreen; else mobile">
					<div class="compare">
						<ng-container *ngFor="let identifier of identifierList; let i = index">
							<stages-edit-translation-single-view
								[inputsByLanguage]="inputsByLanguage"
								[identifier]="identifier"
								[isSourceLanguage]="i === 0"
								[form]="form"
								[translation]="translation"
								(isLoading)="updateIsLoading($event)"
								[type]="_translateParams.beanType"
							/>

							<div *ngIf="i % 2 === 0" class="separator"></div>
						</ng-container>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</form>

	<footer>
		<ng-container *ngTemplateOutlet="buttons; context: { isTop: false }" />
	</footer>
</article>

<ng-template #mobile>
	<div [ngClass]="'mobileView'">
		<stages-edit-translation-single-view
			[inputsByLanguage]="inputsByLanguage"
			[identifier]="'translate.language.a'"
			[form]="form"
			[translation]="translation"
			(isLoading)="updateIsLoading($event)"
			[type]="_translateParams.beanType"
			[isMobileView]="true"
		/>
	</div>
</ng-template>

<ng-template #buttons let-isTop="isTop">
	<stages-buttons-bottom [isOnTop]="isTop">
		<stages-button [title]="'cancel'" [buttonCSS]="'sm cancel'" (clicked)="cancel(translation)" />
		<stages-button
			[buttonType]="'submit'"
			[title]="'save'"
			[buttonCSS]="'sm save'"
			(clicked)="save(translation)"
			[showLoadingSpin]="isLoading"
			[disabled]="form.invalid || isLoading"
		/>
	</stages-buttons-bottom>
</ng-template>
